module.exports = __webpack_public_path__ + "img/githubLogo.3700a24a.svg";